import { Component, OnInit } from '@angular/core';
import { BaseDetailPageComponent } from 'src/app/components/pages/base-detail-page/base-detail-page.component';
import BaseDetailPageConfig from 'src/app/models/base-detail-page.config';
import { ProjectsService } from 'src/app/services/api/projects.service';
import { RouteService } from 'src/app/services/route.service';

@Component({
  selector: 'app-projects-checklist-group-detail-page',
  imports: [BaseDetailPageComponent],
  templateUrl: './projects-checklist-group-detail-page.component.html',
  styleUrl: './projects-checklist-group-detail-page.component.scss'
})
export class ProjectsChecklistGroupDetailPageComponent implements OnInit {
  baseDetailPageConfig!: BaseDetailPageConfig;
  checklistGroup?: any;

  constructor(
    private projectsService: ProjectsService,
    private routeService: RouteService
  ) {}

  ngOnInit(): void {
    this.baseDetailPageConfig = {
      pageTitle: 'Checklist Group',
      cardTitle: 'Checklist Group Detail',
      editItemButton: {
        type: 'success',
        title: 'Edit Checklist Group',
        onClick: () => {
          this.routeService.projectsSettingsChecklistGroupUpdate(this.checklistGroup?.checklistGroupId);
        }
      },
      dataList: {
        data: null,
        rows: [
          {
            attribute: 'checklistGroupId',
            label: 'ID',
            value: (item: any) => item.checklistGroupId
          },
          {
            attribute: 'code',
            label: 'Code',
            value: (item: any) => item.code
          },
          {
            attribute: 'name',
            label: 'Name',
            value: (item: any) => item.name
          }
        ]
      },
      apiDetailService: (checklistGroupId: any) => this.projectsService.detailSettingsChecklistGroup(checklistGroupId),
      routeParamName: 'checklistGroupId',
      responseModelName: 'checklistGroup'
    };
  }

  onLoadedDetail(data: any): void {
    this.checklistGroup = data;
  }
}
